// extracted by mini-css-extract-plugin
export var container = "_dm-0";
export var popoverContent = "_dm-1";
export var tosLink = "_dm-2";